import { NgModule } from '@angular/core';
import { PrecisionCheckPipe } from './precision-pipe';

@NgModule({
    imports: [],
    declarations: [
        PrecisionCheckPipe
    ],
    exports: [
        PrecisionCheckPipe
    ]
})
export class PrecisionModule { }
